"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coreLoginInfoReducer = exports.coreLoginInfoActions = exports.TYPES_LOGIN_INFO = void 0;
var _reduxActions = require("redux-actions");
var _stringConsts = require("../constants/stringConsts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CORE_LOGIN_INFO = 'coreLoginInfo';
const SESSION_STORAGE_KEY_SESSION_ID = 'sessionId';
const TYPES_LOGIN_INFO = exports.TYPES_LOGIN_INFO = {
  SET_SESSION_ID: CORE_LOGIN_INFO + 'SetSessionId',
  SET_MENU_DATA: CORE_LOGIN_INFO + 'SetMenuData',
  SET_SYSTEM_SETTINGS: CORE_LOGIN_INFO + 'SetSystemSettings',
  SET_LOGIN_USER: CORE_LOGIN_INFO + 'SetLoginUser',
  SET_SYSTEM_LINK: CORE_LOGIN_INFO + 'SetSystemLink',
  SET_DOCUMENT_LINK: CORE_LOGIN_INFO + 'SetDocumentLink',
  SET_MAIL_FLG: CORE_LOGIN_INFO + 'SetMailFlg',
  REMOVE_SESSION_ID: CORE_LOGIN_INFO + 'RemoveSessionId',
  INIT: CORE_LOGIN_INFO + 'Init'
};
const initState = () => {
  const loadSessionId = sessionStorage.getItem(SESSION_STORAGE_KEY_SESSION_ID);
  return {
    sessionId: loadSessionId ? loadSessionId : undefined,
    menuData: [],
    systemSettings: {},
    systemLink: {},
    mailFlg: false,
    loginUser: {
      ja: {
        kaishaCd: '',
        shainId: '',
        soshikiCd: '',
        kaishaNm: '',
        shainNm: '',
        shainSei: '',
        shainMei: '',
        soshikiNm: '',
        soshikiNmFull: ''
      },
      en: {
        kaishaCd: '',
        shainId: '',
        soshikiCd: '',
        kaishaNm: '',
        shainNm: '',
        shainSei: '',
        shainMei: '',
        soshikiNm: '',
        soshikiNmFull: ''
      }
    }
  };
};
const coreLoginInfoActions = exports.coreLoginInfoActions = (0, _reduxActions.createActions)({
  [TYPES_LOGIN_INFO.SET_SESSION_ID]: function () {
    return {
      sessionId: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOGIN_INFO.SET_MENU_DATA]: function () {
    return {
      menuData: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOGIN_INFO.SET_SYSTEM_SETTINGS]: function () {
    return {
      settings: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOGIN_INFO.SET_LOGIN_USER]: function () {
    return {
      loginUser: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOGIN_INFO.SET_SYSTEM_LINK]: function () {
    return {
      systemLink: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOGIN_INFO.SET_DOCUMENT_LINK]: function () {
    return {
      documentLink: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOGIN_INFO.SET_MAIL_FLG]: function () {
    return {
      mailFlg: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES_LOGIN_INFO.REMOVE_SESSION_ID, TYPES_LOGIN_INFO.INIT);
const coreLoginInfoReducer = exports.coreLoginInfoReducer = (0, _reduxActions.handleActions)({
  [TYPES_LOGIN_INFO.SET_SESSION_ID]: (state, action) => {
    sessionStorage.setItem(SESSION_STORAGE_KEY_SESSION_ID, action.payload.sessionId);
    localStorage.removeItem(_stringConsts.LOCAL_STORAGE_KEY.FILTER_BY_DATE);
    return _objectSpread(_objectSpread({}, state), {}, {
      sessionId: action.payload.sessionId
    });
  },
  [TYPES_LOGIN_INFO.SET_MENU_DATA]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      menuData: action.payload.menuData
    });
  },
  [TYPES_LOGIN_INFO.SET_SYSTEM_SETTINGS]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      systemSettings: action.payload.settings
    });
  },
  [TYPES_LOGIN_INFO.SET_LOGIN_USER]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      loginUser: action.payload.loginUser
    });
  },
  [TYPES_LOGIN_INFO.SET_SYSTEM_LINK]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      systemLink: action.payload.systemLink
    });
  },
  [TYPES_LOGIN_INFO.SET_DOCUMENT_LINK]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      documentLink: action.payload.documentLink
    });
  },
  [TYPES_LOGIN_INFO.SET_MAIL_FLG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      mailFlg: action.payload.mailFlg
    });
  },
  [TYPES_LOGIN_INFO.REMOVE_SESSION_ID]: (state, action) => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY_SESSION_ID);
    localStorage.removeItem(_stringConsts.LOCAL_STORAGE_KEY.FILTER_BY_DATE);
    return _objectSpread(_objectSpread({}, state), {}, {
      sessionId: undefined
    });
  },
  [TYPES_LOGIN_INFO.INIT]: () => {
    return initState();
  }
}, initState());